import { createContext } from 'react'

/**
 * True for anything rendered inside `Table`. The table wrapper scrolls sideways
 * (`overflow-x: auto`), which also clips vertically, so popups such as select menus
 * must render outside it (see `SelectDropDown`).
 */
export const TableScrollContext = createContext(false)
